<div class="card flex flex-col ">
  <app-referrer-whitelist
    (deleted)="getListKey()"
  ></app-referrer-whitelist>

  <app-mobile-key
    (deleted)="getListIP()"
  ></app-mobile-key>
</div>
